import { type UseQueryResult, useQuery } from "@tanstack/react-query";

import type { ErdGraphResponse } from "@busright/data-contract";

// The dynamic full ERD (Iteration D) — `/api/erd` serves the real join graph across all ~69+
// objects in the three datasets, replacing the hardcoded ERD_TABLES/REAL_EDGES/BROKEN_EDGES
// constants that used to live in DsErdCanvas. Self-contained fetch (own file, own request helper)
// so this doesn't touch the shared api-client.ts / queries.ts modules other surfaces depend on.
const getErd = async (): Promise<ErdGraphResponse> => {
  const res = await fetch("/api/erd", { credentials: "include" });
  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as { error?: string } | null;
    throw new Error(body?.error ?? `HTTP ${res.status}`);
  }
  return (await res.json()) as ErdGraphResponse;
};

// `retry: false` so a not-yet-live endpoint surfaces immediately as an error state — the ERD
// canvas never fabricates nodes/edges, it just shows the empty/error state honestly.
export const useErd = (): UseQueryResult<ErdGraphResponse> =>
  useQuery({ queryKey: ["erd"] as const, queryFn: getErd, retry: false });
